import { Box, Grid, Typography } from '@mui/material';

import * as Styles from '../../../assets/styles/appStyles';
import { gridContainer, infoGridItem } from '../Styles/CustodianAddressDetailsStyles';
import { MailingAddressViewModel } from '../../../Models/custodian/custodian-details-viewmodel';

export default function MailingAddressDetails({
    mailingDetails,
}: Readonly<{
    mailingDetails?: MailingAddressViewModel | null;
}>) {
    return (
        mailingDetails ? (
            <Grid rowSpacing={3} container sx={gridContainer}>
                <Grid item xs={6} sx={infoGridItem}>
                    <Typography align="left" sx={Styles.labelTitle}>
                        Address
                    </Typography>
                    <Box>
                        <Typography sx={Styles.labelText}>
                            {mailingDetails?.addressDetails}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={2} sx={infoGridItem}>
                    <Typography align="left" sx={Styles.labelTitle}>
                        City
                    </Typography>
                    <Box>
                        <Typography sx={Styles.labelText}>
                            {mailingDetails?.city}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={2} sx={infoGridItem}>
                    <Typography align="left" sx={Styles.labelTitle}>
                        State
                    </Typography>
                    <Box>
                        <Typography sx={Styles.labelText}>
                            {mailingDetails?.state}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={2} sx={infoGridItem}>
                    <Typography align="left" sx={Styles.labelTitle}>
                        Zip/Postal Code
                    </Typography>
                    <Box>
                        <Typography sx={Styles.labelText}>
                            {mailingDetails?.postCode}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={3} sx={infoGridItem}>
                    <Typography align="left" sx={Styles.labelTitle}>
                        TimeZone
                    </Typography>
                    <Box>
                        <Typography sx={Styles.labelText}>
                            {mailingDetails?.timeZone}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        ) : <Grid container spacing={2} mt={2} p={2}>
            No Mailing Details
        </Grid>
    );
}
